import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  createSupportRequest(request: string) {
    const completeUrl = this.createCompleteUrl('support/');
    return this.http.post(completeUrl, { "data": request });
  }
}
